import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Slide,
    TextField,
    Typography
} from '@mui/material';
import { motion } from 'framer-motion';
import { useState } from 'react';

export default function LinkDialog({ open, onClose, onSubmit }) {
    const [url, setUrl] = useState('');
    const [isValid, setIsValid] = useState(false);

    const handleChange = (e) => {
        const value = e.target.value;
        setUrl(value);
        setIsValid(value.trim().length > 0);
    };

    const handleSubmit = () => {
        if (url.trim()) {
            onSubmit(url);
            setUrl('');
            setIsValid(false);
        }
    };

    const handleClose = () => {
        setUrl('');
        setIsValid(false);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            TransitionComponent={Slide}
            TransitionProps={{ direction: 'up' }}
            PaperProps={{
                component: motion.div,
                initial: { scale: 0.9, opacity: 0 },
                animate: { scale: 1, opacity: 1 },
                exit: { scale: 0.9, opacity: 0 },
                transition: { duration: 0.2 },
                sx: {
                    borderRadius: 3,
                    overflow: 'visible'
                }
            }}
        >
            <DialogTitle sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                pb: 1
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant='span'>Insert Link</Typography>
                </Box>
                <IconButton
                    onClick={handleClose}
                    size="small"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box
                    component={motion.div}
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.15 }}
                >
                    <TextField
                        autoFocus
                        margin="dense"
                        label="URL"
                        type="url"
                        fullWidth
                        variant="outlined"
                        value={url}
                        onChange={handleChange}
                        onKeyUp={(e) => {
                            if (e.key === 'Enter' && isValid) {
                                handleSubmit();
                            }
                        }}
                        placeholder="https://example.com"
                    // InputProps={{
                    //     endAdornment: (
                    //         <AnimatePresence>
                    //             {isValid && (
                    //                 <motion.div
                    //                     initial={{ scale: 0, rotate: -180 }}
                    //                     animate={{ scale: 1, rotate: 0 }}
                    //                     exit={{ scale: 0, rotate: 180 }}
                    //                     transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                    //                 >
                    //                     {/* <CheckCircleIcon color="success" /> */}
                    //                 </motion.div>
                    //             )}
                    //         </AnimatePresence>
                    //     )
                    // }}
                    // sx={{
                    //     '& .MuiOutlinedInput-root': {
                    //         transition: 'all 0.3s ease',
                    //         '&:focus-within': {
                    //             transform: 'scale(1.01)',
                    //         }
                    //     }
                    // }}
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                <Button
                    onClick={handleClose}
                    variant='contained'
                    color='error'
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!isValid}
                    sx={{
                        background: isValid
                            ? 'success.main'
                            : undefined
                    }}
                >
                    Insert Link
                </Button>
            </DialogActions>
        </Dialog>
    );
};